// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AiImageInsertController from "./ai_image_insert_controller"
application.register("ai-image-insert", AiImageInsertController)

import AssistantComposerController from "./assistant_composer_controller"
application.register("assistant-composer", AssistantComposerController)

import AssistantThreadController from "./assistant_thread_controller"
application.register("assistant-thread", AssistantThreadController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import BacklogReviewController from "./backlog_review_controller"
application.register("backlog-review", BacklogReviewController)

import BookingQuestionsController from "./booking_questions_controller"
application.register("booking-questions", BookingQuestionsController)

import BookingScheduleController from "./booking_schedule_controller"
application.register("booking-schedule", BookingScheduleController)

import BookingTimezoneController from "./booking_timezone_controller"
application.register("booking-timezone", BookingTimezoneController)

import BudgetLineController from "./budget_line_controller"
application.register("budget-line", BudgetLineController)

import BulkActionsController from "./bulk_actions_controller"
application.register("bulk-actions", BulkActionsController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import CalendarDayController from "./calendar_day_controller"
application.register("calendar-day", CalendarDayController)

import CalendarFilterController from "./calendar_filter_controller"
application.register("calendar-filter", CalendarFilterController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ChatBoostController from "./chat_boost_controller"
application.register("chat-boost", ChatBoostController)

import ChatBoostPickerController from "./chat_boost_picker_controller"
application.register("chat-boost-picker", ChatBoostPickerController)

import ChatComposerController from "./chat_composer_controller"
application.register("chat-composer", ChatComposerController)

import ChatLayoutController from "./chat_layout_controller"
application.register("chat-layout", ChatLayoutController)

import ChatMessageController from "./chat_message_controller"
application.register("chat-message", ChatMessageController)

import ChatPushController from "./chat_push_controller"
application.register("chat-push", ChatPushController)

import ChatRoomController from "./chat_room_controller"
application.register("chat-room", ChatRoomController)

import ChatRoomKindController from "./chat_room_kind_controller"
application.register("chat-room-kind", ChatRoomKindController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CloudContextMenuController from "./cloud_context_menu_controller"
application.register("cloud-context-menu", CloudContextMenuController)

import CloudDragController from "./cloud_drag_controller"
application.register("cloud-drag", CloudDragController)

import CloudInspectorController from "./cloud_inspector_controller"
application.register("cloud-inspector", CloudInspectorController)

import CloudSelectController from "./cloud_select_controller"
application.register("cloud-select", CloudSelectController)

import CloudToolbarController from "./cloud_toolbar_controller"
application.register("cloud-toolbar", CloudToolbarController)

import CloudTreeController from "./cloud_tree_controller"
application.register("cloud-tree", CloudTreeController)

import CloudUploadController from "./cloud_upload_controller"
application.register("cloud-upload", CloudUploadController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import CommandPaletteController from "./command_palette_controller"
application.register("command-palette", CommandPaletteController)

import ConfirmModalController from "./confirm_modal_controller"
application.register("confirm-modal", ConfirmModalController)

import DocumentPreviewController from "./document_preview_controller"
application.register("document-preview", DocumentPreviewController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import DrawerOpenerController from "./drawer_opener_controller"
application.register("drawer-opener", DrawerOpenerController)

import DropdownToggleController from "./dropdown_toggle_controller"
application.register("dropdown-toggle", DropdownToggleController)

import EstimateChatController from "./estimate_chat_controller"
application.register("estimate-chat", EstimateChatController)

import EstimateController from "./estimate_controller"
application.register("estimate", EstimateController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FocusController from "./focus_controller"
application.register("focus", FocusController)

import FormFieldsController from "./form_fields_controller"
application.register("form-fields", FormFieldsController)

import GanttController from "./gantt_controller"
application.register("gantt", GanttController)

import GlobalSearchController from "./global_search_controller"
application.register("global-search", GlobalSearchController)

import HillChartController from "./hill_chart_controller"
application.register("hill-chart", HillChartController)

import HotkeyController from "./hotkey_controller"
application.register("hotkey", HotkeyController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import KanbanController from "./kanban_controller"
application.register("kanban", KanbanController)

import MermaidInsertController from "./mermaid_insert_controller"
application.register("mermaid-insert", MermaidInsertController)

import MermaidRendererController from "./mermaid_renderer_controller"
application.register("mermaid-renderer", MermaidRendererController)

import NotificationBellController from "./notification_bell_controller"
application.register("notification-bell", NotificationBellController)

import PdfPreviewController from "./pdf_preview_controller"
application.register("pdf-preview", PdfPreviewController)

import PlannerController from "./planner_controller"
application.register("planner", PlannerController)

import PlannerFormController from "./planner_form_controller"
application.register("planner-form", PlannerFormController)

import PmBoardController from "./pm_board_controller"
application.register("pm-board", PmBoardController)

import PmListController from "./pm_list_controller"
application.register("pm-list", PmListController)

import PmTaskboardController from "./pm_taskboard_controller"
application.register("pm-taskboard", PmTaskboardController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import PopupController from "./popup_controller"
application.register("popup", PopupController)

import ProgressBarController from "./progress_bar_controller"
application.register("progress-bar", ProgressBarController)

import ProposalChatController from "./proposal_chat_controller"
application.register("proposal-chat", ProposalChatController)

import ProposalCompleteTabsController from "./proposal_complete_tabs_controller"
application.register("proposal-complete-tabs", ProposalCompleteTabsController)

import ProposalModeController from "./proposal_mode_controller"
application.register("proposal-mode", ProposalModeController)

import ProposalSectionsController from "./proposal_sections_controller"
application.register("proposal-sections", ProposalSectionsController)

import ProposalTabsController from "./proposal_tabs_controller"
application.register("proposal-tabs", ProposalTabsController)

import QuestionReplyController from "./question_reply_controller"
application.register("question-reply", QuestionReplyController)

import QuickAddController from "./quick_add_controller"
application.register("quick-add", QuickAddController)

import QuickReplyController from "./quick_reply_controller"
application.register("quick-reply", QuickReplyController)

import RangeController from "./range_controller"
application.register("range", RangeController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import RolePermissionsController from "./role_permissions_controller"
application.register("role-permissions", RolePermissionsController)

import RoomsListController from "./rooms_list_controller"
application.register("rooms-list", RoomsListController)

import SaasComparisonController from "./saas_comparison_controller"
application.register("saas-comparison", SaasComparisonController)

import SectionNavController from "./section_nav_controller"
application.register("section-nav", SectionNavController)

import SectionPlanController from "./section_plan_controller"
application.register("section-plan", SectionPlanController)

import SelectionToolbarController from "./selection_toolbar_controller"
application.register("selection-toolbar", SelectionToolbarController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SidebarSectionController from "./sidebar_section_controller"
application.register("sidebar-section", SidebarSectionController)

import StatusPickerController from "./status_picker_controller"
application.register("status-picker", StatusPickerController)

import SupplierKindController from "./supplier_kind_controller"
application.register("supplier-kind", SupplierKindController)

import TablePasteController from "./table_paste_controller"
application.register("table-paste", TablePasteController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TimelineController from "./timeline_controller"
application.register("timeline", TimelineController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import TimesheetEntryController from "./timesheet_entry_controller"
application.register("timesheet-entry", TimesheetEntryController)

import TimesheetTimerController from "./timesheet_timer_controller"
application.register("timesheet-timer", TimesheetTimerController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)

import VideoRecorderController from "./video_recorder_controller"
application.register("video-recorder", VideoRecorderController)

import WhiteboardChatController from "./whiteboard_chat_controller"
application.register("whiteboard-chat", WhiteboardChatController)

import WhiteboardChatPanelController from "./whiteboard_chat_panel_controller"
application.register("whiteboard-chat-panel", WhiteboardChatPanelController)

import WorkspaceHotkeysController from "./workspace_hotkeys_controller"
application.register("workspace-hotkeys", WorkspaceHotkeysController)
